function init() {
  const button = document.querySelector('.c-category_filter');

  if (!button) {
    return;
  }

  button.addEventListener('click', (e) => {
    button.classList.toggle("c-category_filter__active");
  });

}

export default init;
